import { NgModule } from '@angular/core';
import { UtilsService } from '@core/services/utils/utils.service';
import { KeysBlockDirective } from '@core/services/utils/key-block.directive';
import { DownloadReportService } from '@core/services/utils/download-report.service';
import { EncryptionService } from '@core/services/utils/encryption.service';
@NgModule({
    declarations: [KeysBlockDirective],
    exports:[KeysBlockDirective],
    providers: [
        UtilsService,
        DownloadReportService,
        EncryptionService

    ]
})
export class UtilsModule { }
